import React from 'react';
import { Link } from "react-router-dom";
import img from "../assets/img/me.jpeg";
import cv from "../assets/pdf/CVCodyMACEDOWeb.pdf";

const Resume = () => {
    return (
        <div className="App-header" id="resume">
            <div className="container">
                <div className="homepage">
                    <div className="logo">
                        <img src={img} alt="Portrait de Cody Macedo"/>
                    </div>
                    <div className="hero-content">
                        <h1>CODY MACEDO</h1>
                        <p className="hero-subtitle">Développeur full-stack web et mobile</p>
                        <p>
                            Je conçois et maintiens des applications métier avec <span className="bold-text">Angular, .NET et Android/Kotlin</span>,
                            de l'interface utilisateur jusqu'aux API et bases de données. Mon objectif : livrer des solutions fiables, lisibles et utiles aux équipes qui les exploitent.
                        </p>
                        <div className="hero-actions">
                            <a target="_blank" href={cv} className="link-text" rel="noreferrer">Curriculum Vitae</a>
                            <Link to="/contact" className="hero-link-secondary">Me contacter</Link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Resume;
